import { ListOfNotUniqueEnumValues } from '.';
import { getOptionsListEnum, getOptionsListValues } from '../../../services/common/miscUtils';

const appendIds = <T extends Array<{ label: string; value: QuoteSchema.Schemas.CountryCodeType; postalCode?: string }>>(
  list: T
) => {
  return list.map(({ label, value, postalCode }) => ({ label, value, id: `${label}-${value}`, postalCode }));
};

export const countryCodesOptions = appendIds([
  { label: 'France', value: 'FR', postalCode: '' },
  { label: 'Andorre', value: 'AD', postalCode: '99130' },
  { label: 'Émirats arabes unis', value: 'AE', postalCode: '99247' },
  { label: 'Afghanistan', value: 'AF', postalCode: '99212' },
  { label: 'Antigua-et-Barbuda', value: 'AG', postalCode: '99441' },
  { label: 'Anguilla', value: 'AI', postalCode: '99425' },
  { label: 'Albanie', value: 'AL', postalCode: '99125' },
  { label: 'Arménie', value: 'AM', postalCode: '99252' },
  { label: 'Angola', value: 'AO', postalCode: '99395' },
  { label: 'Antarctique', value: 'AQ', postalCode: '' },
  { label: 'Argentine', value: 'AR', postalCode: '99415' },
  { label: 'Samoa américaines', value: 'AS', postalCode: '99505' },
  { label: 'Autriche', value: 'AT', postalCode: '99110' },
  { label: 'Australie', value: 'AU', postalCode: '99501' },
  { label: 'Aruba', value: 'AW', postalCode: '99135' },
  { label: 'Îles Åland', value: 'AX', postalCode: '' },
  { label: 'Azerbaïdjan', value: 'AZ', postalCode: '99253' },
  { label: 'Bosnie-Herzégovine', value: 'BA', postalCode: '99118' },
  { label: 'Barbade', value: 'BB', postalCode: '99434' },
  { label: 'Bangladesh', value: 'BD', postalCode: '99246' },
  { label: 'Belgique', value: 'BE', postalCode: '99131' },
  { label: 'Burkina Faso', value: 'BF', postalCode: '99331' },
  { label: 'Bulgarie', value: 'BG', postalCode: '99111' },
  { label: 'Bahreïn', value: 'BH', postalCode: '99249' },
  { label: 'Burundi', value: 'BI', postalCode: '99321' },
  { label: 'Bénin', value: 'BJ', postalCode: '99327' },
  { label: 'Saint-Barthélemy', value: 'BL', postalCode: '' },
  { label: 'Bermudes', value: 'BM', postalCode: '99425' },
  { label: 'Brunéi Darussalam', value: 'BN', postalCode: '99225' },
  { label: 'Bolivie, État plurinational de', value: 'BO', postalCode: '99418' },
  { label: 'Bonaire, Saint-Eustache et Saba', value: 'BQ', postalCode: '99443' },
  { label: 'Brésil', value: 'BR', postalCode: '99416' },
  { label: 'Bahamas', value: 'BS', postalCode: '99436' },
  { label: 'Bhoutan', value: 'BT', postalCode: '99214' },
  { label: 'Bouvet, Île', value: 'BV', postalCode: '99103' },
  { label: 'Botswana', value: 'BW', postalCode: '99347' },
  { label: 'Bélarus', value: 'BY', postalCode: '99148' },
  { label: 'Belize', value: 'BZ', postalCode: '99429' },
  { label: 'Canada', value: 'CA', postalCode: '99401' },
  { label: 'Cocos (Keeling), Îles', value: 'CC', postalCode: '99501' },
  { label: 'Congo, République démocratique du', value: 'CD', postalCode: '99312' },
  { label: 'Centrafricaine, République', value: 'CF', postalCode: '99323' },
  { label: 'Congo', value: 'CG', postalCode: '99324' },
  { label: 'Suisse', value: 'CH', postalCode: '99140' },
  { label: "Côte d'Ivoire", value: 'CI', postalCode: '99326' },
  { label: 'Cook, Îles', value: 'CK', postalCode: '99502' },
  { label: 'Chili', value: 'CL', postalCode: '99417' },
  { label: 'Cameroun', value: 'CM', postalCode: '99322' },
  { label: 'Chine', value: 'CN', postalCode: '99216' },
  { label: 'Colombie', value: 'CO', postalCode: '99419' },
  { label: 'Costa Rica', value: 'CR', postalCode: '99406' },
  { label: 'Cuba', value: 'CU', postalCode: '99407' },
  { label: 'Cabo Verde', value: 'CV', postalCode: '99396' },
  { label: 'Curaçao', value: 'CW', postalCode: '99444' },
  { label: 'Christmas, Île', value: 'CX', postalCode: '99501' },
  { label: 'Chypre', value: 'CY', postalCode: '99254' },
  { label: 'Tchéquie', value: 'CZ', postalCode: '99116' },
  { label: 'Allemagne', value: 'DE', postalCode: '99109' },
  { label: 'Djibouti', value: 'DJ', postalCode: '99399' },
  { label: 'Danemark', value: 'DK', postalCode: '99101' },
  { label: 'Dominique', value: 'DM', postalCode: '99438' },
  { label: 'Dominicaine, République', value: 'DO', postalCode: '99408' },
  { label: 'Algérie', value: 'DZ', postalCode: '99352' },
  { label: 'Équateur', value: 'EC', postalCode: '99420' },
  { label: 'Estonie', value: 'EE', postalCode: '99106' },
  { label: 'Égypte', value: 'EG', postalCode: '99301' },
  { label: 'Sahara occidental', value: 'EH', postalCode: '99389' },
  { label: 'Érythrée', value: 'ER', postalCode: '99317' },
  { label: 'Espagne', value: 'ES', postalCode: '99134' },
  { label: 'Éthiopie', value: 'ET', postalCode: '99315' },
  { label: 'Finlande', value: 'FI', postalCode: '99105' },
  { label: 'Fidji', value: 'FJ', postalCode: '99508' },
  { label: 'Falkland, Îles (Malvinas)', value: 'FK', postalCode: '99427' },
  { label: 'Micronésie, États fédérés de', value: 'FM', postalCode: '99516' },
  { label: 'Féroé, Îles', value: 'FO', postalCode: '99101' },
  { label: 'Gabon', value: 'GA', postalCode: '99328' },
  { label: "Royaume-Uni de Grande-Bretagne et d'Irlande du Nord", value: 'GB', postalCode: '99132' },
  { label: 'Grenade', value: 'GD', postalCode: '99435' },
  { label: 'Géorgie', value: 'GE', postalCode: '99255' },
  { label: 'Guyane française', value: 'GF', postalCode: '' },
  { label: 'Guernesey', value: 'GG', postalCode: '99132' },
  { label: 'Ghana', value: 'GH', postalCode: '99329' },
  { label: 'Gibraltar', value: 'GI', postalCode: '99133' },
  { label: 'Groenland', value: 'GL', postalCode: '99430' },
  { label: 'Gambie', value: 'GM', postalCode: '99304' },
  { label: 'Guinée', value: 'GN', postalCode: '99330' },
  { label: 'Guadeloupe', value: 'GP', postalCode: '' },
  { label: 'Guinée équatoriale', value: 'GQ', postalCode: '99314' },
  { label: 'Grèce', value: 'GR', postalCode: '99126' },
  { label: 'Géorgie du Sud-et-les Îles Sandwich du Sud', value: 'GS', postalCode: '99427' },
  { label: 'Guatemala', value: 'GT', postalCode: '99409' },
  { label: 'Guam', value: 'GU', postalCode: '99505' },
  { label: 'Guinée-Bissau', value: 'GW', postalCode: '99392' },
  { label: 'Guyana', value: 'GY', postalCode: '99428' },
  { label: 'Hong Kong', value: 'HK', postalCode: '99230' },
  { label: 'Heard-et-Îles MacDonald, Île', value: 'HM', postalCode: '99501' },
  { label: 'Honduras', value: 'HN', postalCode: '99411' },
  { label: 'Croatie', value: 'HR', postalCode: '99119' },
  { label: 'Haïti', value: 'HT', postalCode: '99410' },
  { label: 'Hongrie', value: 'HU', postalCode: '99112' },
  { label: 'Indonésie', value: 'ID', postalCode: '99231' },
  { label: 'Irlande', value: 'IE', postalCode: '99136' },
  { label: 'Israël', value: 'IL', postalCode: '99207' },
  { label: 'Île de Man', value: 'IM', postalCode: '99132' },
  { label: 'Inde', value: 'IN', postalCode: '99223' },
  { label: "Océan Indien, Territoire britannique de l'", value: 'IO', postalCode: '99308' },
  { label: 'Iraq', value: 'IQ', postalCode: '99203' },
  { label: "Iran, République islamique d'", value: 'IR', postalCode: '99204' },
  { label: 'Islande', value: 'IS', postalCode: '99102' },
  { label: 'Italie', value: 'IT', postalCode: '99127' },
  { label: 'Jersey', value: 'JE', postalCode: '99132' },
  { label: 'Jamaïque', value: 'JM', postalCode: '99426' },
  { label: 'Jordanie', value: 'JO', postalCode: '99222' },
  { label: 'Japon', value: 'JP', postalCode: '99217' },
  { label: 'Kenya', value: 'KE', postalCode: '99332' },
  { label: 'Kirghizistan', value: 'KG', postalCode: '99257' },
  { label: 'Cambodge', value: 'KH', postalCode: '99234' },
  { label: 'Kiribati', value: 'KI', postalCode: '99513' },
  { label: 'Comores', value: 'KM', postalCode: '99397' },
  { label: 'Saint-Kitts-et-Nevis', value: 'KN', postalCode: '99442' },
  { label: 'Corée, République populaire démocratique de', value: 'KP', postalCode: '99238' },
  { label: 'Corée, République de', value: 'KR', postalCode: '99239' },
  { label: 'Koweït', value: 'KW', postalCode: '99240' },
  { label: 'Caïmans, Îles', value: 'KY', postalCode: '99425' },
  { label: 'Kazakhstan', value: 'KZ', postalCode: '99256' },
  { label: 'Lao, République démocratique populaire', value: 'LA', postalCode: '99241' },
  { label: 'Liban', value: 'LB', postalCode: '99205' },
  { label: 'Sainte-Lucie', value: 'LC', postalCode: '99439' },
  { label: 'Liechtenstein', value: 'LI', postalCode: '99113' },
  { label: 'Sri Lanka', value: 'LK', postalCode: '99235' },
  { label: 'Libéria', value: 'LR', postalCode: '99302' },
  { label: 'Lesotho', value: 'LS', postalCode: '99348' },
  { label: 'Lituanie', value: 'LT', postalCode: '99108' },
  { label: 'Luxembourg', value: 'LU', postalCode: '99137' },
  { label: 'Lettonie', value: 'LV', postalCode: '99107' },
  { label: 'Libye', value: 'LY', postalCode: '99316' },
  { label: 'Maroc', value: 'MA', postalCode: '99350' },
  { label: 'Monaco', value: 'MC', postalCode: '99138' },
  { label: 'Moldova, République de', value: 'MD', postalCode: '99151' },
  { label: 'Monténégro', value: 'ME', postalCode: '99120' },
  { label: 'Saint-Martin (partie française)', value: 'MF', postalCode: '' },
  { label: 'Madagascar', value: 'MG', postalCode: '99333' },
  { label: 'Marshall, Îles', value: 'MH', postalCode: '99515' },
  { label: 'Macédoine du Nord', value: 'MK', postalCode: '99156' },
  { label: 'Mali', value: 'ML', postalCode: '99335' },
  { label: 'Myanmar', value: 'MM', postalCode: '99224' },
  { label: 'Mongolie', value: 'MN', postalCode: '99242' },
  { label: 'Macao', value: 'MO', postalCode: '99232' },
  { label: 'Mariannes du Nord, Îles', value: 'MP', postalCode: '99505' },
  { label: 'Martinique', value: 'MQ', postalCode: '' },
  { label: 'Mauritanie', value: 'MR', postalCode: '99336' },
  { label: 'Montserrat', value: 'MS', postalCode: '99425' },
  { label: 'Malte', value: 'MT', postalCode: '99144' },
  { label: 'Maurice', value: 'MU', postalCode: '99390' },
  { label: 'Maldives', value: 'MV', postalCode: '99229' },
  { label: 'Malawi', value: 'MW', postalCode: '99334' },
  { label: 'Mexique', value: 'MX', postalCode: '99405' },
  { label: 'Malaisie', value: 'MY', postalCode: '99227' },
  { label: 'Mozambique', value: 'MZ', postalCode: '99393' },
  { label: 'Namibie', value: 'NA', postalCode: '99311' },
  { label: 'Nouvelle-Calédonie', value: 'NC', postalCode: '' },
  { label: 'Niger', value: 'NE', postalCode: '99337' },
  { label: 'Norfolk, Île', value: 'NF', postalCode: '99501' },
  { label: 'Nigéria', value: 'NG', postalCode: '99338' },
  { label: 'Nicaragua', value: 'NI', postalCode: '99412' },
  { label: 'Pays-Bas, Royaume des', value: 'NL', postalCode: '99135' },
  { label: 'Norvège', value: 'NO', postalCode: '99103' },
  { label: 'Népal', value: 'NP', postalCode: '99215' },
  { label: 'Nauru', value: 'NR', postalCode: '99507' },
  { label: 'Niue', value: 'NU', postalCode: '99502' },
  { label: 'Nouvelle-Zélande', value: 'NZ', postalCode: '99502' },
  { label: 'Oman', value: 'OM', postalCode: '99250' },
  { label: 'Panama', value: 'PA', postalCode: '99413' },
  { label: 'Pérou', value: 'PE', postalCode: '99422' },
  { label: 'Polynésie française', value: 'PF', postalCode: '' },
  { label: 'Papouasie-Nouvelle-Guinée', value: 'PG', postalCode: '99510' },
  { label: 'Philippines', value: 'PH', postalCode: '99220' },
  { label: 'Pakistan', value: 'PK', postalCode: '99213' },
  { label: 'Pologne', value: 'PL', postalCode: '99122' },
  { label: 'Saint-Pierre-et-Miquelon', value: 'PM', postalCode: '' },
  { label: 'Pitcairn', value: 'PN', postalCode: '99503' },
  { label: 'Porto Rico', value: 'PR', postalCode: '99432' },
  { label: 'Palestine, État de', value: 'PS', postalCode: '99261' },
  { label: 'Portugal', value: 'PT', postalCode: '99139' },
  { label: 'Palaos', value: 'PW', postalCode: '99517' },
  { label: 'Paraguay', value: 'PY', postalCode: '99421' },
  { label: 'Qatar', value: 'QA', postalCode: '99248' },
  { label: 'Réunion', value: 'RE', postalCode: '' },
  { label: 'Roumanie', value: 'RO', postalCode: '99114' },
  { label: 'Serbie', value: 'RS', postalCode: '99121' },
  { label: 'Russie, Fédération de', value: 'RU', postalCode: '99123' },
  { label: 'Rwanda', value: 'RW', postalCode: '99340' },
  { label: 'Arabie saoudite', value: 'SA', postalCode: '99201' },
  { label: 'Salomon, Îles', value: 'SB', postalCode: '99512' },
  { label: 'Seychelles', value: 'SC', postalCode: '99398' },
  { label: 'Soudan', value: 'SD', postalCode: '99343' },
  { label: 'Suède', value: 'SE', postalCode: '99104' },
  { label: 'Singapour', value: 'SG', postalCode: '99226' },
  { label: 'Sainte-Hélène, Ascension et Tristan da Cunha', value: 'SH', postalCode: '99306' },
  { label: 'Slovénie', value: 'SI', postalCode: '99145' },
  { label: "Svalbard et l'Île Jan Mayen", value: 'SJ', postalCode: '99103' },
  { label: 'Slovaquie', value: 'SK', postalCode: '99117' },
  { label: 'Sierra Leone', value: 'SL', postalCode: '99342' },
  { label: 'Saint-Marin', value: 'SM', postalCode: '99128' },
  { label: 'Sénégal', value: 'SN', postalCode: '99341' },
  { label: 'Somalie', value: 'SO', postalCode: '99318' },
  { label: 'Suriname', value: 'SR', postalCode: '99437' },
  { label: 'Sao Tomé-et-Principe', value: 'ST', postalCode: '99394' },
  { label: 'El Salvador', value: 'SV', postalCode: '99414' },
  { label: 'Saint-Martin (partie néerlandaise)', value: 'SX', postalCode: '99445' },
  { label: 'Syrienne, République arabe', value: 'SY', postalCode: '99206' },
  { label: 'Eswatini', value: 'SZ', postalCode: '99391' },
  { label: 'Turks-et-Caïcos, Îles', value: 'TC', postalCode: '99425' },
  { label: 'Tchad', value: 'TD', postalCode: '99344' },
  { label: 'Terres australes françaises', value: 'TF', postalCode: '' },
  { label: 'Togo', value: 'TG', postalCode: '99345' },
  { label: 'Thaïlande', value: 'TH', postalCode: '99219' },
  { label: 'Tadjikistan', value: 'TJ', postalCode: '99259' },
  { label: 'Tokelau', value: 'TK', postalCode: '99502' },
  { label: 'Timor-Leste', value: 'TL', postalCode: '99262' },
  { label: 'Turkménistan', value: 'TM', postalCode: '99260' },
  { label: 'Tunisie', value: 'TN', postalCode: '99351' },
  { label: 'Tonga', value: 'TO', postalCode: '99509' },
  { label: 'Türkiye', value: 'TR', postalCode: '99208' },
  { label: 'Trinité-et-Tobago', value: 'TT', postalCode: '99433' },
  { label: 'Tuvalu', value: 'TV', postalCode: '99511' },
  { label: 'Taïwan, Province de Chine', value: 'TW', postalCode: '99236' },
  { label: 'Tanzanie, République-Unie de', value: 'TZ', postalCode: '99309' },
  { label: 'Ukraine', value: 'UA', postalCode: '99155' },
  { label: 'Ouganda', value: 'UG', postalCode: '99339' },
  { label: 'Îles mineures éloignées des États-Unis', value: 'UM', postalCode: '99505' },
  { label: "États-Unis d'Amérique", value: 'US', postalCode: '99404' },
  { label: 'Uruguay', value: 'UY', postalCode: '99423' },
  { label: 'Ouzbékistan', value: 'UZ', postalCode: '99258' },
  { label: 'Saint-Siège', value: 'VA', postalCode: '99129' },
  { label: 'Saint-Vincent-et-les Grenadines', value: 'VC', postalCode: '99440' },
  { label: 'Venezuela, République bolivarienne du', value: 'VE', postalCode: '99424' },
  { label: 'Vierges britanniques, Îles', value: 'VG', postalCode: '99425' },
  { label: 'Vierges des États-Unis, Îles', value: 'VI', postalCode: '99432' },
  { label: 'Viet Nam', value: 'VN', postalCode: '99243' },
  { label: 'Vanuatu', value: 'VU', postalCode: '99514' },
  { label: 'Wallis-et-Futuna', value: 'WF', postalCode: '' },
  { label: 'Samoa', value: 'WS', postalCode: '99506' },
  { label: 'Yémen', value: 'YE', postalCode: '99251' },
  { label: 'Mayotte', value: 'YT', postalCode: '' },
  { label: 'Afrique du Sud', value: 'ZA', postalCode: '99303' },
  { label: 'Zambie', value: 'ZM', postalCode: '99346' },
  { label: 'Zimbabwe', value: 'ZW', postalCode: '99310' },
]) satisfies ListOfNotUniqueEnumValues<QuoteSchema.Schemas.CountryCodeType>;

export const frenchTerritoriesOptions = appendIds([
  { label: 'France', value: 'FR' },
  { label: 'Antarctique', value: 'AQ' },
  { label: 'Îles Åland', value: 'AX' },
  { label: 'Saint-Barthélemy', value: 'BL' },
  { label: 'Guyane française', value: 'GF' },
  { label: 'Guadeloupe', value: 'GP' },
  { label: 'Saint-Martin (partie française)', value: 'MF' },
  { label: 'Martinique', value: 'MQ' },
  { label: 'Nouvelle-Calédonie', value: 'NC' },
  { label: 'Polynésie française', value: 'PF' },
  { label: 'Saint-Pierre-et-Miquelon', value: 'PM' },
  { label: 'Réunion', value: 'RE' },
  { label: 'Terres australes françaises', value: 'TF' },
  { label: 'Wallis-et-Futuna', value: 'WF' },
  { label: 'Mayotte', value: 'YT' },
]) satisfies ListOfNotUniqueEnumValues<QuoteSchema.Schemas.CountryCodeType>;

export const countryCodesOptionsValues = getOptionsListValues(countryCodesOptions);

export const CountryCodesEnum = getOptionsListEnum(countryCodesOptions);

export const translateCountryCodeToCountry = (value: QuoteSchema.Schemas.CountryCodeType) =>
  countryCodesOptions.find((option) => option.value === value)?.label ?? '';
